import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import styled from 'styled-components';
import { rem } from 'polished';
import { Store } from '../../../constants';
import {
  formatPrice,
  formatStringDate,
  isOutOfStock,
  prop,
} from '../../../utilities';
import { loadStoreProductAvailabilities } from '../../../containers/Product/actions';
import { Loader } from '../Loader/Loader';
import { loadShopDetailDirect } from '../../../containers/ShopDetail/actions';
import { setDeliveryTimesModal } from '../../../containers/App/actions';
import IconLazy from '../Icon/IconLazy';

import loadable from '@loadable/component';

const Wrapper = styled.div`
  display: block;
  position: relative;
  font-size: ${rem(12)};
  margin: 0 0 ${rem(20)} 0;
  padding: ${rem(10)} ${rem(15)};

  &.on-stock {
    background: ${({ theme }) => theme.color.available};
  }

  &.not-available {
    background: ${({ theme }) => theme.color.primary};
    color: ${({ theme }) => theme.color.white};
  }

  ${({ theme }) => theme.media(1024)} {
    font-size: ${rem(14)};
  }
`;
/*
const Icon = styled.div`
  position: absolute;
  top: ${rem(10)};
  right: ${rem(10)};
  width: ${rem(30)};
  height: ${rem(30)};
  line-height: ${rem(30)};
  font-weight: 800;
  text-align: center;
  color: ${({ theme }) => theme.color.black};
  background: ${({ theme }) => theme.color.white};
  border-radius: 50%;

  &:hover {
    cursor: pointer;
  }
`;
*/

const Ul = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

const ShopAvailabilityWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;

const ShopIcon: any = styled(IconLazy)`
  margin-right: ${rem(10)};
  width: ${rem(15)};
  fill: ${({ fill }) => fill};
`;

const ShopAvailabilitiesWrapper = styled.div``;

const ShopLink = styled.div`
  display: inline;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

const SearchAvailabilityText = styled.div`
  text-decoration: underline;
`;

const ExpectedDeliveryText = styled.div`
  display: inline;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

const DeliveryTimeWrapper = styled.div``;

const DeliveryTimeText = styled.div`
  color: #0063a5;
`;

const ShopModal = loadable(() => import('../Modal/ShopModal'));

interface AvailabilityProps {
  dispatch: any;
  className?: string;
  productDetail: any;
}

const AvailabilityDetail = (props: AvailabilityProps) => {
  const { className, productDetail } = props;

  const [shopAvailabilities, setShopAvailabilities] = React.useState(
    null as any,
  );
  const [shopAvailabilitiesLoading, setShopAvailabilitiesLoading] =
    React.useState(false);
  const [modalShopDetail, setModalShopDetail] = React.useState(null as any);

  let availabilityClassName = 'on-stock';
  let isAvailable = true;
  if (isOutOfStock(productDetail)) {
    availabilityClassName = 'not-available';
    isAvailable = false;
  }
  const onstock = prop(productDetail, 'main_good.onstock', []);
  const onstoreChemat = onstock
    .filter((o) => o.storeId === Store.CHEMAT)
    .shift();
  const onstoreExternal = onstock.filter((o) => o.storeId !== Store.CHEMAT);

  const chematStockQty = prop(onstoreChemat, 'storeQty', 0);
  const externalStockQty = onstoreExternal
    .map((item) => prop(item, 'storeQty', 0))
    .reduce((partialSum, a) => partialSum + a, 0);

  const onClickCheckShopAvailabilities = async () => {
    setShopAvailabilitiesLoading(true);
    const loadedShopAvailabilities = await props.dispatch(
      loadStoreProductAvailabilities(productDetail.product_id),
    );
    setShopAvailabilitiesLoading(false);
    setShopAvailabilities(loadedShopAvailabilities);
  };

  const onClickShopDetail = async (shopDetail: any) => {
    const shopDetailFull = await props.dispatch(
      loadShopDetailDirect(shopDetail.id),
    );
    setModalShopDetail(shopDetailFull);
    return true;
  };

  const onCloseShopModal = () => {
    setModalShopDetail(null);
  };

  const onClickDeliveryTimesText = () => {
    props.dispatch(setDeliveryTimesModal(true));
  };

  const renderShopAvailabilities = (color: string) => {
    return !shopAvailabilities ? (
      <ShopAvailabilityWrapper onClick={onClickCheckShopAvailabilities}>
        <ShopIcon icon="shop" fill={color} />
        <SearchAvailabilityText>
          {__('Zobraziť dostupnosť v predajniach')}
        </SearchAvailabilityText>
      </ShopAvailabilityWrapper>
    ) : !shopAvailabilities?.availabilities?.length ? (
      <ShopAvailabilityWrapper>
        <ShopIcon icon="shop" fill={color} />
        <div>{__('Produkt nie je dostupný v predajniach')}</div>
      </ShopAvailabilityWrapper>
    ) : (
      <>
        <ShopAvailabilityWrapper>
          <ShopIcon icon="shop" fill={color} />
          <div>{__('Dostupnosť v predajniach')}:</div>
        </ShopAvailabilityWrapper>
        <ShopAvailabilitiesWrapper>
          {shopAvailabilities?.availabilities?.map((shopAvailability) => {
            return (
              <div>
                {' '}
                <b>{shopAvailability.amount} ks</b> -{' '}
                <ShopLink
                  onClick={() => {
                    onClickShopDetail(shopAvailability?.shop);
                  }}
                  href={shopAvailability?.shop?.url}
                >
                  {shopAvailability?.shop?.name}
                </ShopLink>{' '}
              </div>
            );
          })}
        </ShopAvailabilitiesWrapper>
        <div>
          {__(
            'Dostupnosť v predajniach je len orientačná - prosíme, overte si ju telefonicky priamo v predajni.',
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <Loader loading={shopAvailabilitiesLoading}>
        <Wrapper className={`${className} ${availabilityClassName}`}>
          {isAvailable ? (
            <>
              <strong>{__('Tovar je skladom.')}</strong>{' '}
              {productDetail?.delivery_times?.length ? (
                <>
                  {__('Predpokladaný')}{' '}
                  <ExpectedDeliveryText onClick={onClickDeliveryTimesText}>
                    {' '}
                    {__('termín doručenia')}
                  </ExpectedDeliveryText>
                  :
                </>
              ) : (
                __('Dodanie 2 - 5 dní')
              )}
              {productDetail?.delivery_times?.length ? (
                <DeliveryTimeWrapper>
                  {productDetail?.delivery_times.map((deliveryTime) => {
                    return (
                      <DeliveryTimeText>
                        {`${deliveryTime.deliveryDate} - ${deliveryTime.delivery.name} (`}
                        {formatPrice(
                          deliveryTime.price.price,
                          deliveryTime.price.currencyId,
                        )}
                        {`)`}
                      </DeliveryTimeText>
                    );
                  })}
                </DeliveryTimeWrapper>
              ) : (
                <></>
              )}
              {/*
              <Icon onClick={handleIconClick}>?</Icon>
              */}
              <Ul>
                {chematStockQty || externalStockQty ? (
                  <li>
                    {__('Centrálny sklad')}:{' '}
                    {chematStockQty > 1000 ? (
                      <strong>{`${__('viac ako')} 1000 ${__('ks')}`}</strong>
                    ) : (
                      <strong>{`${chematStockQty} ${__('ks')}`}</strong>
                    )}
                  </li>
                ) : (
                  ''
                )}

                {externalStockQty ? (
                  <li>
                    {__('Externý sklad')}:{' '}
                    {externalStockQty > 1000 ? (
                      <strong>{`${__('viac ako')} 1000 ${__('ks')}`}</strong>
                    ) : (
                      <strong>{`${externalStockQty} ${__('ks')}`}</strong>
                    )}
                  </li>
                ) : (
                  ''
                )}
              </Ul>
              {renderShopAvailabilities('blac')}
            </>
          ) : (
            <>
              <strong>{__('Tovar nie je skladom.')}</strong>
              <br />
              {productDetail?.allow_preorder &&
                productDetail?.main_good?.restock_date && (
                  <>
                    {__('Predpokladaný dátum naskladnenia')}:{' '}
                    <b>
                      {formatStringDate(
                        productDetail.main_good.restock_date,
                        'DD.MM.YYYY',
                      )}
                    </b>
                  </>
                )}
              {!productDetail?.allow_preorder && (
                <>
                  {__('Tento produkt momentálne nie je možné objednať.')}
                  <br />
                </>
              )}
              {renderShopAvailabilities('white')}
            </>
          )}
        </Wrapper>
      </Loader>

      {modalShopDetail ? (
        <ShopModal
          shopDetail={modalShopDetail}
          onCloseButtonClick={onCloseShopModal}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AvailabilityDetail;
